"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DadosResumidoAlteradoManual = void 0;
var DadosResumidoAlteradoManual = /** @class */ (function () {
    function DadosResumidoAlteradoManual(_a) {
        var _b = _a._id, _id = _b === void 0 ? { material: '', data: '', estacao: '', colecao: '' } : _b;
        this._id = _id;
    }
    return DadosResumidoAlteradoManual;
}());
exports.DadosResumidoAlteradoManual = DadosResumidoAlteradoManual;
//# sourceMappingURL=DadosResumidoAlteradoManual.js.map